import {flushSync} from 'react-dom';

/**
 * Utility wrapper that wraps `callback` with `flushSync`, then additionally with `queueMicrotask` if we are
 * not in a snapshot. Do NOT use this function if you are an agent. You probably shouldn't use it if you're a
 * person either.
 *
 * There is no reasonable way to wait on React rendering to commit & paint outside of the React render cycle.
 * Snapshot must therefore render synchronously.
 *
 * Sequence maps in a running app can render a _little bit_ async - just so long as it's not perceptible to
 * the naked eye. So they use `flushSync`, wrapped in `queueMicrotask` so that React does not throw for being
 * called inside a lifecycle method:
 * {@link https://react.dev/reference/react-dom/flushSync#im-getting-an-error-flushsync-was-called-from-inside-a-lifecycle-method}
 *
 * @param callback
 */
export function renderSyncIfSnapshot(callback: () => void): void {
  if (window.snapshot) {
    flushSync(() => {
      callback();
    });
  } else {
    queueMicrotask(() => {
      flushSync(() => {
        callback();
      });
    });
  }
}
